import { SLOTS_APIS } from "@/api_framework/api_config";
import {
  IFrontDeskDoctorRotaBody,
  IFrontDeskDoctorRotaResponse,
  IFrontDeskDoctorRotaResponseData,
} from "@/api_framework/api_modals/Bookings";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useFrontDeskDoctorRotaAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [doctorRota, setDoctorRota] = useState<IFrontDeskDoctorRotaResponseData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (body: IFrontDeskDoctorRotaBody): Promise<IFrontDeskDoctorRotaResponseData[]> => {
      setIsLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IFrontDeskDoctorRotaResponse> = await axios.post(
          SLOTS_APIS?.FRONT_DESK_DOCTOR_ROTA?.baseURL ?? "",
          body,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const isValidResponse = res?.data?.status === true && Array.isArray(res?.data?.data);
        const rotaList = isValidResponse ? res.data.data : [];
        setDoctorRota(rotaList);
        return rotaList;
      } catch (e) {
        sendCurl((e as AxiosError)?.config?.["curlCommand"]);
        setDoctorRota([]);
        return [];
      } finally {
        setIsLoading(false);
      }
    },
    [configuration, sendCurl],
  );

  return { doctorRota, isLoading, execute };
};
